// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__wJH_x","type":"styles_type__6GlXO","choices":"styles_choices__1_QiD"};